import { Component, OnDestroy, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges, ViewEncapsulation, HostListener } from '@angular/core';
import { take, of, from, Subject, Observable } from 'rxjs';
import { map, filter, finalize, concatMap, switchMap, tap, debounceTime, distinctUntilChanged, takeUntil, toArray } from 'rxjs/operators';

import { Router } from '@angular/router';

import { MessageService } from 'primeng/api';

import { environment } from 'src/environments/environment';

import { Person } from 'src/app/shared/person';
import { Client } from 'src/app/shared/client';
import { DocTypes } from 'src/app/shared/doc-list-entry';
import { Document, DocItems, DocInheritanceRule, emptyDocument } from 'src/app/shared/document';

import { GlobalSettingsData } from 'src/app/shared/global-settings-data'
import { GetglobalsettingsService } from 'src/app/services/getglobalsettings.service'
import { DocumentStackService } from 'src/app/services/document-stack.service'

import { DocumentApiService } from 'src/app/services/document-api.service';
import { ClientApiService } from 'src/app/services/client-api.service';
import { AgentDataApiService } from 'src/app/services/agent-data-api.service';
import { DocItemPricingService } from 'src/app/services/doc-item-pricing.service';
import { BankPaymentDocumentService } from 'src/app/services/bank-payment-document.service';
import { AgentDocumentSeed } from 'src/app/shared/agent-data';

/*
 * TODO: 1) CreateNewDocuments - simple movement between departments
 * TODO: 2) CreateNewDocuments - Inventory
 */
/*
    DOCID: number;
    DOCTYPE: number;
    DOCDATE: Date;
    DOCEXPDATE: Date;
    DOCVALDATE: Date;
    DOCCLIENTSID: number;
    DOCPERSONID: number;
    DOCMANCLIID: number;
    DOCMANPERID: number;
    DOCNUMBER: string;
    DOCDLVBASE: string;
    DOCDLVTERM: number;
    DOCNOTE1: string;
    DOCNOTE2: string;
    PRIMDOCID: number;
    DOCCLIDEPID: number;
    DOCMANDEPID: number;
    DOCTOTALDISCOUNT: number;
    DOCCURRID: number;
    DOCRATEVAL: number;
    DOCACTIVE: number;
    DOCFLAG: number;
    DOCLCOCLIID: number;
    DOCLCOPERID: number;
    DOCLCODEPID: number;
    DOCPCOCLIID: number;
    DOCPCOPERID: number;
    DOCPCODEPID: number;
    DOCNUMBEREX ?: string;
    DOCNAMESTR ?: string;
    DOCSUM ?: number;
    DOCVSUM ?: number;
    DOCSUMWOVAT ?: number;
    DOCVAT ?: number;
    DOCITEMS ?: number;
    DOCTOTALITEMS ?: number;
    DOCSUMU4ETKA ?: number;
    DOCPAIDSUM ?: number;
    DOCSHIPSUM ?: number;
    SGMGROUPID ?: number;

 */

interface DocumentTypeConfig {
  action:             number;
  docType:            number;
  header:             string;
  /** Which dates sub-template to render */
  datesVariant:       'standard' | 'receipt' | 'shipment-spec' | 'transaction' | 'po' | 'payment' | 'inventory';
  companiesVariant:   'standard' | 'receipt' | 'inventory';
  processVariant:     'invoice' | 'receipt' | 'shipment' | 'po' | 'payment' |
                      'spec' | 'transaction' | 'inventory' | 'formular';
  showSearch:         boolean;
  /** null = hide tab entirely */
  conditionsVariant:  'standard' | 'receipt' | 'po' | 'notes' | 'formular-notes' | null;
  /** Initial collapsed state of the conditions accordion tab */
  conditionsSelected: boolean;
  /** Label override for conditions tab header; null = 'Условия поставки' */
  conditionsLabel:    string | null;
  showDiscount:       boolean;
  showReserve:        boolean;
  showShipped:        boolean;
  showNote:           boolean;
  showU4etka:         boolean;
  showDocItems:       boolean;
}

const allowedChild: DocInheritanceRule[] = [
  { DOCTYPE: 1, AllowedChildTypes: [1, 2, 4, 5, 6, 7, 8, 9, 11, 12] },
  { DOCTYPE: 2, AllowedChildTypes: [2, 3, 5, 7] },
  { DOCTYPE: 3, AllowedChildTypes: [2, 3, 5, 7] },
  { DOCTYPE: 4, AllowedChildTypes: [5, 7] },
  { DOCTYPE: 5, AllowedChildTypes: [5, 7] },
  { DOCTYPE: 6, AllowedChildTypes: [] },
  { DOCTYPE: 7, AllowedChildTypes: [7,16] },
  { DOCTYPE: 8, AllowedChildTypes: [] },
  { DOCTYPE: 9, AllowedChildTypes: [] },
  { DOCTYPE: 10, AllowedChildTypes: [2, 3, 7, 10] },
  { DOCTYPE: 11, AllowedChildTypes: [] },
  { DOCTYPE: 12, AllowedChildTypes: [1, 12] },
  { DOCTYPE: 13, AllowedChildTypes: [] },
  { DOCTYPE: 14, AllowedChildTypes: [5,7] },
  { DOCTYPE: 15, AllowedChildTypes: [] },
  { DOCTYPE: 16, AllowedChildTypes: [7,16] },
];


const documentTypeConfigs: DocumentTypeConfig[] = [
  { action:  1, docType: 12, header: 'Коммерческое предложение',
    datesVariant: 'standard',      companiesVariant: 'standard',  processVariant: 'invoice',
    showSearch: true,  conditionsVariant: 'standard', conditionsSelected: true,  conditionsLabel: null,
    showDiscount: false, showReserve: false, showShipped: false, showNote: false, showU4etka: false, showDocItems: true },

  { action:  2, docType:  1, header: 'Счет',
    datesVariant: 'standard',      companiesVariant: 'standard',  processVariant: 'invoice',
    showSearch: true,  conditionsVariant: 'standard', conditionsSelected: true,  conditionsLabel: null,
    showDiscount: true,  showReserve: true,  showShipped: true,  showNote: true,  showU4etka: true,  showDocItems: true },

  // action 3: companiesVariant is 'standard' (template uses app-new-document-dlg-companies, not receipt)
  { action:  3, docType:  3, header: 'Приходная накладная',
    datesVariant: 'receipt',       companiesVariant: 'standard',  processVariant: 'receipt',
    showSearch: true,  conditionsVariant: 'receipt',  conditionsSelected: true,  conditionsLabel: null,
    showDiscount: false, showReserve: false, showShipped: false, showNote: false, showU4etka: false, showDocItems: true },

  // action 4: template has standard conditions tab
  { action:  4, docType:  4, header: 'Отгрузка',
    datesVariant: 'shipment-spec', companiesVariant: 'standard',  processVariant: 'shipment',
    showSearch: true,  conditionsVariant: 'standard', conditionsSelected: true,  conditionsLabel: null,
    showDiscount: false, showReserve: false, showShipped: false, showNote: false, showU4etka: false, showDocItems: true },

  // action 5: companiesVariant 'receipt' renders the transaction recipient tab
  { action:  5, docType:  5, header: 'Накладная на перемещение',
    datesVariant: 'transaction',   companiesVariant: 'receipt',   processVariant: 'transaction',
    showSearch: false, conditionsVariant: 'notes',    conditionsSelected: true,  conditionsLabel: 'Комментарии к перемещению',
    showDiscount: false, showReserve: false, showShipped: false, showNote: false, showU4etka: false, showDocItems: false },

  // action 6: template HAS search; uses conditions-receipt for warranty notes
  { action:  6, docType:  7, header: 'Гарантийный талон',
    datesVariant: 'shipment-spec', companiesVariant: 'standard',  processVariant: 'spec',
    showSearch: true,  conditionsVariant: 'notes',    conditionsSelected: true,  conditionsLabel: 'Гарантийные условия',
    showDiscount: false, showReserve: false, showShipped: false, showNote: false, showU4etka: false, showDocItems: false },

  { action:  7, docType: 10, header: 'Заказ поставщика',
    datesVariant: 'po',            companiesVariant: 'standard',  processVariant: 'po',
    showSearch: true,  conditionsVariant: 'po',       conditionsSelected: true,  conditionsLabel: null,
    showDiscount: false, showReserve: false, showShipped: false, showNote: false, showU4etka: false, showDocItems: true },

  // action 9: conditions tab exists but collapsed; process NOT guarded by parentDocument
  { action:  9, docType:  9, header: 'Оплата',
    datesVariant: 'payment',       companiesVariant: 'standard',  processVariant: 'payment',
    showSearch: true,  conditionsVariant: 'standard', conditionsSelected: false, conditionsLabel: null,
    showDiscount: false, showReserve: false, showShipped: false, showNote: false, showU4etka: false, showDocItems: true },

  // action 10: process uses app-new-document-dlg-process-receipt (not a separate inventory component)
  { action: 10, docType:  6, header: 'Инвентаризация',
    datesVariant: 'inventory',     companiesVariant: 'inventory', processVariant: 'inventory',
    showSearch: false, conditionsVariant: 'notes',    conditionsSelected: true,  conditionsLabel: 'Комментарии к инвентаризации',
    showDiscount: false, showReserve: false, showShipped: false, showNote: false, showU4etka: false, showDocItems: true },

  // action 16: template HAS search; uses process-spec component (same as spec); conditions-receipt with extra labels
  { action: 16, docType: 16, header: 'Паспорт изделия',
    datesVariant: 'shipment-spec', companiesVariant: 'standard',  processVariant: 'formular',
    showSearch: true,  conditionsVariant: 'formular-notes', conditionsSelected: true, conditionsLabel: 'Информация о производстве',
    showDiscount: false, showReserve: false, showShipped: false, showNote: false, showU4etka: false, showDocItems: false },
];

/**
 * Modal dialog wizard for creating or cloning business documents.
 *
 * ### Action types (driven by `documentTypeConfigs`)
 * | action | DOCTYPE | Label                      |
 * |--------|---------|----------------------------|
 * | 1      | 12      | Коммерческое предложение   |
 * | 2      | 1       | Счет                       |
 * | 3      | 3       | Приходная накладная        |
 * | 4      | 4       | Отгрузка                   |
 * | 5      | 5       | Накладная на перемещение   |
 * | 6      | 7       | Гарантийный талон          |
 * | 7      | 10      | Заказ поставщика           |
 * | 9      | 9       | Оплата                     |
 * | 10     | 6       | Инвентаризация             |
 * | 16     | 16      | Паспорт изделия            |
 *
 * ### Three creation modes (controlled by `ngOnChanges`)
 * 1. **Standalone** — neither `parentDocumentId` nor `selectedDocumentId` set;
 *    user selects an action from the type tabs.
 * 2. **Child** — `parentDocumentId` is set; `canCreate(docType)` filters the
 *    tab list using the `allowedChild` inheritance table.
 * 3. **Clone/re-base** — both IDs set; the selected document's items are copied
 *    into the new document of the chosen type.
 *
 * ### Subjects & pipelines
 * - `cliCompanySubs$` — debounced client-company lookups; switched on every new CLIID.
 * - `selectedDocSubs$` — switched load of the selected (child) document; triggers
 *   the appropriate `onCreateXxx` handler based on DOCTYPE.
 * - `loadParentDocument$` — switched load of the parent document and its items
 *   (calls `calculateDocItemsFields` after load).
 * - `destroy$` — `takeUntil` guard used across all long-lived `subscribe` calls.
 *
 * On save, `doSaveDocument` POSTs or PUTs the document + all items sequentially.
 * `done` emits `true` on success, `false` on error.
 */
@Component({
  selector: 'app-create-new-document',
  templateUrl: './create-new-document.component.html',
  styleUrls: ['./create-new-document.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class CreateNewDocumentComponent implements OnInit, OnChanges, OnDestroy {
  private globalSettinsData: GlobalSettingsData;

  debugMode: boolean = !environment.production;

  /** Controls dialog visibility; two-way bound via `displayChange`. */
  @Input()  display: boolean = false;

  /** Dialog header text (overrides default). */
  @Input()  header: string = 'Создать документ';

  /** DOCID of the parent document; when set, the dialog opens in child-creation mode. */
  @Input() parentDocumentId: number = null;

  //@Input()
  parentDocument: Document = null;

  /** DOCID of an existing document to clone/re-base the new document on. */
  @Input() selectedDocumentId: number = null;

  /** When true, empty doc-items rows are included in the items table. */
  @Input() countEmptyDocItems: boolean = false;

  /** `AgentRequests.id` -- when set, the dialog opens on the "AI Assist" tab (tab 2) so
   *  the manager can pre-fill `newDocument` from the claimed Teams request instead of
   *  starting blank. See `docs/PROMPT_agent-intake-confirmation-panel.md`. */
  @Input() agentRequestId: number = null;

  /** Bank-payment review MVP (`docs/PROMPT_agent-bank-payment-review-mvp.md`) --
   *  when set together with `parentDocumentId`, `onCreateChildPayment()` is
   *  invoked automatically once the parent invoice loads (skipping the manual
   *  "Провести оплату" click) and seeds the new payment's amount/date from
   *  this instead of the usual zero/today defaults. The manager still makes
   *  the final Save click -- this only prefills, it never auto-saves. */
  @Input() bankPaymentSeed: { amountDecimal: number; bookingDate: Date | null } = null;

  //@Input()
  selectedDocument: Document = null;

  //@Output() newDocuments: EventEmitter<Document[]> = new EventEmitter();

  /** Emits false to close the dialog (two-way binding partner for `display`). */
  @Output() displayChange = new EventEmitter();

  /** Emits true on successful save, false on error. */
  @Output() done = new EventEmitter<boolean>();     // True = ok, delete is done

  /** Emits once, only after a save's header + all items have actually
   *  persisted (never merely because the dialog opened or the header POST
   *  alone returned) -- the real DOCID a caller like the bank-payment review
   *  dialog needs to record its own outcome. Additive to `done`, which every
   *  existing caller still relies on unchanged. */
  @Output() documentSaved = new EventEmitter<{ documentId: number; doctype: number }>();

  modal: boolean = true;

  blocked: boolean = false;

  parentDocumentNumberStr: string = '';

  public get hasParentDocument(): boolean { return (this.parentDocumentId && true); }

  public get parentDocumentNumber(): string {
    return ((this.hasParentDocument && this.parentDocument) ? this.parentDocument.DOCNUMBEREX : '');
  }

  tabIndex: number = 0;

  docTypes: DocTypes[] = null;

  private readonly destroy$ = new Subject<void>();

  collapsedClient: boolean = true;

  cliCompany: Client = null;
  pcoCompany: Client = null;
  cliPerson: Person = null;
  pcoPerson: Person = null;

  lcoPerson: Person = null;
  lcoPersons: Person[] = null;

  private cliCompanySubs$ = new Subject<number>();
  private selectedDocSubs$ = new Subject<number>();

  private loadParentDocument$ = new Subject < { parentdocid: number, sdloader: () => void }>();

  /**
   * Returns true when the parent document's DOCTYPE permits creating a child of the given type.
   * Uses the `allowedChild` inheritance table. Always returns false when no parent document is loaded.
   */
  canCreate(docType: number): boolean {
    if (!this.parentDocument) return false;
    const rule = allowedChild.find(r => r.DOCTYPE === this.parentDocument.DOCTYPE);
    return rule?.AllowedChildTypes.includes(docType) ?? false;
  }

  /** Returns the `DocumentTypeConfig` entry matching the currently active `action`, or null when no action is selected. */
  get activeConfig(): DocumentTypeConfig | null {
    return documentTypeConfigs.find(c => c.action === this.action) ?? null;
  }

  /** True while the "AI Assist" tab (index 2) is the one on screen. That tab renders the
   *  dates/search/companies/conditions blocks itself, interleaved with the agent's own
   *  findings, so this dialog's own copy of that accordion must stay hidden -- otherwise
   *  every block would appear twice, bound to the same `newDocument`. */
  get isAgentTabActive(): boolean {
    return (this.agentRequestId ? true : false) && (this.tabIndex === 2);
  }

  public get isLcoDep(): boolean { return this.newDocument && (this.newDocument.DOCLCODEPID ? true : false); }

  public get isLcoPer(): boolean { return this.newDocument && (this.newDocument.DOCLCOPERID ? true : false); }

  public get isNewDoc(): boolean { return this.newDocument && (this.newDocument.DOCTYPE ? true : false); }

  public get ready2Create(): boolean {

    return this.isNewDoc && this.isLcoDep && this.isLcoPer && ((this.newDocument != null) || ((this.newDocuments || []).length > 0));
  }

  // Can be used to determine if we need to navigate to newly created document
  // Use along with navigateTo flag
  // TODO: convert navigateTo to getter/setter pair

  public get singleDocumentOutput(): boolean {
    return this.newDocuments && (this.newDocuments.length < 2);
  }

  // 1 - Create Proforma
  // 2 - Create Invoice
  // 3 - Create Receipt
  // 4 - Create Shipment
  // 5 - Create Transaction
  // 6 - Create Specification
  // 7 - Create PurchOrder
  // 9 - Create Payment
  // 10 - Inventory Checking result
  // 16 - Create Formular

  action: number = 0; // { some named options }

  newDocument: Document = {
    DOCID: null,
    DOCTYPE: null,
    DOCDATE: new Date,
    DOCEXPDATE: new Date,
    DOCVALDATE: new Date,
    DOCCLIENTSID: null,
    DOCPERSONID: null,
    DOCMANCLIID: null,
    DOCMANPERID: null,
    DOCNUMBER: null,
    DOCDLVBASE: null,
    DOCDLVTERM: null,
    DOCNOTE1: null,
    DOCNOTE2: null,
    PRIMDOCID: null,
    DOCCLIDEPID: null,
    DOCMANDEPID: null,
    DOCTOTALDISCOUNT: null,
    DOCCURRID: null,
    DOCRATEVAL: null,
    DOCACTIVE: null,
    DOCFLAG: null,
    DOCLCOCLIID: null,
    DOCLCOPERID: null,
    DOCLCODEPID: null,
    DOCPCOCLIID: null,
    DOCPCOPERID: null,
    DOCPCODEPID: null,
  };

  newDocuments: Document[] = null;

  parentDocItems: DocItems[] = null;

  dateFormat: string = 'dd.mm.yy';

  public get checkSelectedClientData(): boolean {
    return !(
      (this.newDocument ? true : false) &&
      ((this.newDocument.DOCTYPE == 5) ||
        (
          (this.newDocument.DOCCLIENTSID ? true : false) &&
          (this.newDocument.DOCPERSONID ? true : false) &&
          (this.newDocument.DOCPCOCLIID ? true : false) &&
          (this.newDocument.DOCPCOPERID ? true : false)
        )
      )
    );
  }

  public get needClentSearch(): boolean { return (this.parentDocument ? false : true); }

  // Count all items in newDocuments array if any exist
  public get docContentIsReady(): boolean {
    return (this.newDocument && this.newDocument.items && (this.newDocument.items.length > 0)) ||
      (((this.newDocuments || []).reduce((r, s) => r += (s.items || []).length, 0)) > 0);           
  }

  poDocOptText1: string = 'Оплата';
  poOptions1: string[] = [
    'Full payment in advance',
    'Partial payment in advance',
    'CREDIT 30 DAY',
    ];

  poSelected1: string = 'CREDIT 30 DAY';

  poDocOptText2: string = 'Отгрузка/Заказ';
  poOptions2: string[] = [
    'Order',
    'PO30',
    'PO60',
    'PO90',
    ];

  poSelected2: string = 'Order';

  poDocOptText3: string = 'Доставка';

  poOptions3: string[] = [
    'CIP KYIV',
    'FCA TAIBEI',
    ];

  poSelected3: string = 'FCA TAIBEI';

  navigateTo: boolean = true;

  resultPartnerName: string = '';

  transactionResult: Record<string, unknown>[] | null = null;
  transactionResultColumns: string[] = [];

  openDateAndCurrencyTab: boolean = false;
  openRecipientTab: boolean = false;
  openTransactionDetailTab: boolean = false;

  manProcessEnded: boolean = false;

  constructor(
    private documentStack: DocumentStackService,
    private docApi: DocumentApiService,
    private cliApi: ClientApiService,
    private globalsettingsservice: GetglobalsettingsService,
    private agentDataApi: AgentDataApiService,
    private pricing: DocItemPricingService,
    private bankPaymentDocs: BankPaymentDocumentService,
    private router: Router,
    private messageService: MessageService,
  ) {

    this.loadParentDocument$.pipe(

        debounceTime(100),
        distinctUntilChanged(),
        takeUntil(this.destroy$),

        switchMap(info =>
          this.docApi.getDocumentById(info.parentdocid).pipe(
            filter(data => data && (data.length > 0)),

            // Load parent document body
            map(data => {
              this.parentDocument = data[0];
              this.parentDocumentNumberStr = this.parentDocument.DOCNUMBEREX;
              this.tabIndex = 1;
              environment.production || console.log('*** CreateNewDocumentComponent in map loadParentDocument: ===> ' + JSON.stringify(this.parentDocument));

              return this.parentDocument;
            }),

            // Load parent document items
            concatMap(doc => this.docApi.getDocItemsByDoc(doc.DOCID).pipe(map(data => this.calculateDocItemsFields(data)))),

            finalize(() => {
              environment.production || console.log('*** CreateNewDocumentComponent in loadParentDocument$ B2: finalize');

              info.sdloader();
            })
          )
        )
      ).subscribe({
        next: next => {
          environment.production || console.log('*** CreateNewDocumentComponent in loadParentDocument$ B3: subscribe next: ' + JSON.stringify(next));
        },
        error: err => {
          environment.production || console.log('*** CreateNewDocumentComponent in loadParentDocument$ B3: subscribe error: ' + JSON.stringify(err));
        },
        complete: () => {
          environment.production || console.log('*** CreateNewDocumentComponent in loadParentDocument$ B3: subscribe complete: ');
        }
      });

    this.cliCompanySubs$.pipe(
        debounceTime(100),
        distinctUntilChanged(),
        takeUntil(this.destroy$),
        switchMap(cli => this.cliApi.getClientById(cli).pipe(map((data) => {
          environment.production || console.log('*** CreateNewDocumentComponent cliCompanySubs$: ' + JSON.stringify(data));

          this.cliCompany = data[0];
          this.resultPartnerName = '';

          if (this.newDocument && this.cliCompany) {
            this.resultPartnerName = ': ' + this.cliCompany.CLIENTSNIKNAME;
            if (this.cliCompany.CURID) {
              this.newDocument.DOCCURRID = this.cliCompany.CURID;
            }
          }
        })))
      )
        .subscribe();

    this.selectedDocSubs$.pipe(
        debounceTime(100),
        distinctUntilChanged(),
        takeUntil(this.destroy$),

        switchMap(docId => this.docApi.getDocumentById(docId))
      )
        .subscribe((data) => {
          environment.production || console.log('*** CreateNewDocumentComponent selectedDocSubs$: ' + JSON.stringify(data));

          this.selectedDocument = data[0];

          if (this.selectedDocument) {
            environment.production || console.log('*** CreateNewDocumentComponent in loadSelectedDocument: selectedDocument: ===> ' + JSON.stringify(this.selectedDocument));

            // Will be called in onCreateXxxxx functions

            switch (this.selectedDocument.DOCTYPE) {
              case 1:
                this.onCreateChildInvoice(null);
                break;

              case 2:
              case 3:
                this.onCreateChildIncomeReceipt(null);
                break;

              case 4:
                this.onCreateChildShipment(null);
                break;

              case 5:
                this.onCreateChildTransaction(null);
                break;

              case 7:
                this.onCreateChildSpecification(null);
                break;

              case 10:
                this.onCreateChildPurchOrder(null);
                break;

              case 12:
                this.onCreateChildProforma(null);
                break;

              case 8:
              case 9:
              case 11:
                this.onCreateChildPayment(null);
                break;
            }
          }
        });
  }

  /**
   * Route-deactivation guard; also fires on browser refresh/close via `@HostListener`.
   * Currently always returns `true` (navigation without confirmation).
   * Replace `return true` with prompt logic when unsaved-change detection is needed.
   */
  @HostListener('window:beforeunload')
  canDeactivate(): Observable<boolean> | boolean {
    return true;
  }

  /**
   * Reacts to `@Input` changes:
   * - `display` — when `true`, resets draft state, selects the correct tab
   *   (tab 1 when a parent document is already loaded, tab 0 otherwise), and
   *   queues loading of `selectedDocumentId` or `parentDocumentId` as appropriate.
   *
   * ### Priority order when multiple IDs are set
   * 1. `selectedDocumentId` — triggers `loadSelectedDocument` (which first loads
   *    the parent, then queues the selected document).
   * 2. `parentDocumentId` — triggers `loadParentDocument` directly.
   */
  ngOnChanges(changes: SimpleChanges) {

    /*
     * Possible cases:
     *
     * 1) neither parentDocument nor selectedDocument available - simply create new document
     * 2) parentDocument available - we would create new child document
     * 3) both parentDocument and selectedDocument available - we would update content of selectedDocument (even change the type)
     *
     * parentDocument, if exists, have to be initialized first, selectedDocument - next one.
     *
     * *) parentDocumentId has more priority over parentDocument
     * *) selectedDocumentId has more priority over selectedDocument
     * done fired when both newDocument and newDocment.items are ready.
     * 
     */

    for (const propName of Object.keys(changes)) {
      const change = changes[propName];

      environment.production || console.log('*** CreateNewDocumentComponent ngOnChanges ' + propName + ' (actual): ' + JSON.stringify(change.currentValue));

      switch (propName) {

        case 'display':
          if (this.display) {
            this.tabIndex = this.agentRequestId ? 2 : (this.parentDocument ? 1 : 0);

            this.selectedDocument = null;
            this.newDocument = null;
            this.newDocuments = [];

            if (this.selectedDocumentId) {

              this.loadSelectedDocument();
            } else
              if (this.parentDocumentId) {

                this.loadParentDocument(() => {
                  environment.production || console.log('*** CreateNewDocumentComponent parentDocumentId: ===> loadParentDocument ends');

                  // Bank-payment review MVP: skip the manual "Провести оплату"
                  // click when a seed is present -- go straight to a payment
                  // editor already showing the confirmed bank amount/date.
                  if (this.bankPaymentSeed) {
                    this.onCreateChildPayment(null);
                  }
                });
              }
          }
          break;
      }
    }
  }

  /**
   * Populates derived fields on each `DocItems` entry (VAT, DOCITEMSUM, DOCITEMVSUM,
   * DOCITEMSHIPPED) and stores the result in `this.parentDocItems`.
   * For invoice-type items (DOCTYPE=1) it queries the shipped-qty API and updates
   * `DOCITEMSHIPPED` in place.
   */
  calculateDocItemsFields(data: DocItems[]) {
    environment.production || console.log('*** CreateNewDocumentComponent in calculateDocItemsFields: ===> ' + JSON.stringify(data));
    this.parentDocItems = data;

    // Using from + concatMap to process items one by one (if needed)

    from(this.parentDocItems).pipe(
        concatMap(di => {
          di.PRODVAT = (di.PRODVAT ?? this.globalSettinsData.vatValue);
          di.DOCITEMSUM = di.DOCITEMQTY * di.DOCITEMPRICE;
          di.DOCITEMVSUM = di.DOCITEMQTY * di.DOCITEMVPRICE;
          di.DOCITEMSHIPPED = 0;
          return of(di);
        }),
        filter(di => di.DOCTYPE == 1),
        concatMap(di => this.docApi.getDocItemsShippedByDoc(di.DOCITEMID, new Date()).pipe(
          filter(data => data && data.length > 0),
          map(data => {
            di.DOCITEMSHIPPED = data[0].DOCITEMSHIPPED;
            return di;
          })
      )),
        takeUntil(this.destroy$))
      .subscribe();
  }

  /**
   * Triggers loading of the parent document (by `parentDocumentId`) and its items.
   * Delegates to the `loadParentDocument$` Subject so requests are debounced and previous
   * in-flight requests are cancelled via `switchMap`.
   * `sdLoader` is called from `finalize` when the load pipeline ends (success or error).
   */
  loadParentDocument(sdLoader: () => void) {

    this.loadParentDocument$.next({
      parentdocid: this.parentDocumentId,
      sdloader: sdLoader
    });

  }

  /**
   * Loads the parent document first (via `loadParentDocument`), then queues a load of
   * `selectedDocumentId` via `selectedDocSubs$`.  The `selectedDocSubs$` handler then calls
   * the appropriate `onCreateXxx` based on the selected document's DOCTYPE.
   */
  loadSelectedDocument() {

    this.loadParentDocument(() => {
      environment.production || console.log('*** CreateNewDocumentComponent in map loadSelectedDocument (' + ')');
      this.selectedDocSubs$.next(this.selectedDocumentId);
    });
  }

  /** Completes `destroy$` to cancel all `takeUntil`-guarded subscriptions. */
  ngOnDestroy(): void {
    console.log('*** CreateNewDocumentComponent in ngOnDestroy');
    this.destroy$.next();
    this.destroy$.complete();
  }

  /**
   * Sets `this.action` and `this.navigateTo` after a document-creation pipeline completes.
   * Called from the `finalize` operator of each `onCreateXxx` handler.
   * `action` is the UI selector value — NOT the DOCTYPE (see the action/DOCTYPE mapping table in the source).
   */
  private _finalizeDocumentCreation(action: number, navigateTo: boolean = true): void {
    this.action = action;
    this.navigateTo = navigateTo;
    environment.production || console.log('*** CreateNewDocumentComponent _finalizeDocumentCreation: action=' + action + ', newDocument=' + JSON.stringify(this.newDocument));
  }

  /**
   * Loads global settings, fetches the available `DocTypes`, and wires up the
   * three long-lived Subjects (`cliCompanySubs$`, `selectedDocSubs$`,
   * `loadParentDocument$`) with their `switchMap`/`concatMap` pipelines.
   */
  ngOnInit(): void {
    environment.production || console.log('*** CreateNewDocumentComponent in ngOnInit');

    this.globalSettinsData = this.globalsettingsservice.getGlobalSettings();

    this.docApi.getDocTypes().pipe(map(data => this.docTypes = data), takeUntil(this.destroy$)).subscribe();
  }

  /** Called by PrimeNG dialog `(onShow)` — debug hook. */
  onShowDialog() {
    environment.production || console.log('*** CreateNewDocumentComponent onShow: ');
  }

  /** Resets `action` to 0 and emits `false` via `displayChange` to close the dialog. */
  onHideDialog() {
    environment.production || console.log('*** CreateNewDocumentComponent onHide');

    this.action = 0; // Do not remember last action
    this.displayChange.emit(false);
  }

  /**
   * Handles PrimeNG tab-panel selection changes.
   * - Tab 0 (standalone): clears `parentDocument`, `selectedDocument`, and `parentDocItems`.
   * - Tab 1 (child / clone): triggers `loadSelectedDocument` to reload the selected document.
   */
  onTabChange(event) {
    environment.production || console.log('*** CreateNewDocumentComponent onTabChange');

    switch (this.tabIndex) {
      case 0:
        this.parentDocument =null;
        this.selectedDocument = null;
        this.parentDocItems = [];

        break;

      case 1:
        this.loadSelectedDocument();
        break;

      case 2:
        break;
    }
  }

  /**
   * Persists a single document and all its items.
   * POST when `doc.DOCID` is null or -2 (new document); PUT otherwise (update).
   * Returns an Observable that completes after all items are saved.
   * Navigation and side-effects must be handled in the caller's `subscribe({ complete })` — NOT here.
   */
  doSaveDocument(doc: Document): Observable<any> {
    environment.production || console.log('*** CreateNewDocumentComponent doSaveDocument: ' + JSON.stringify(doc));
    environment.production || console.table(doc);

    if ((doc.DOCID ?? -2) == -2) {
      return this.docApi.postDocumentById(doc)
        .pipe(
          concatMap(data => { doc.DOCID = data['DOCID']; return of(doc); }),
          concatMap(savedDoc => from(savedDoc.items)
            .pipe(
              concatMap(di => this.docApi.postDocItemById({ ...di, DOCID: savedDoc.DOCID, cloneIndex: 0 }))
            )));
    } else {
      return this.docApi.putDocumentById(doc)
        .pipe(
          concatMap(() => from(doc.items)
            .pipe(
              concatMap(di => this.docApi.postDocItemById({ ...di, DOCID: doc.DOCID, cloneIndex: 0 }))
            )));
    }
  }

  /**
   * Saves `newDocument` (or each document in `newDocuments`) via `doSaveDocument`.
   * On success emits `done(true)` and navigates to the edit-document view when `navigateTo` is true.
   * On error emits `done(false)` and leaves the dialog open.
   * Sets `blocked=true` while saving; clears it and closes the dialog on finalize.
   */
  onCreateDocument(event) {
    environment.production || console.log('*** CreateNewDocumentComponent onCreateDocument');
    /*
     * NOTE!
     *
     * newDocument: Document
     * newDocuments: Document[]
     *
     * In general we come here with empty newDocuments array and properly filled newDocument
     * Therefore we could save single document and navigate to it
     *
     * BUT in case we generate movement, manufacturing and something else, we would process queue from newDocuments
     * and would navigate to last one or simply update caller state
     *
     * BUT we need to check if there is content in newDocument.
     * Some procedure uses newDocument as template for newDocuments and should clear it before the exit
     *
     */

    const doc: Document[] =
      (this.newDocuments && (this.newDocuments.length > 0)) ?
        this.newDocuments : [[5, 6].includes(this.action)
          ? this.parentDocument
            ? null : this.newDocument : this.newDocument];

    const docs: number = doc.length;

    environment.production || console.table([this.newDocument]);
    environment.production || console.table(this.newDocuments);
    environment.production || console.table(doc);

    this.blocked = true;

    // Which document to report back to the agent request, or null if nothing reached the
    // server. Derived from the input array rather than from the pipe's emissions:
    // doSaveDocument() emits one postDocItemById response per line item -- not the
    // document -- and emits nothing at all for a document with no items, so its output
    // cannot say what was saved. It does write the real DOCID back onto the input object
    // (`doc.DOCID = data['DOCID']`), which is what the previous `doc[0].DOCID` relied on.
    // Read after the chain settles this is also correct when the chain failed partway:
    // whatever was saved before the error already carries its DOCID, everything else is
    // still -2.
    const savedDocumentId = (): number | null => {
      const saved: Document = doc.find(singleDoc => singleDoc && singleDoc.DOCID > 0);
      return saved ? saved.DOCID : null;
    };

    from(doc).pipe(
        filter(singleDoc => !!singleDoc),
        concatMap(singleDoc => this.doSaveDocument(singleDoc)),
        takeUntil(this.destroy$),
        finalize(() => {
          this.blocked = false;
          this.display = false;
        })
      ).subscribe({
        complete: () => {
          this.done.emit(true);

          const savedId: number | null = savedDocumentId();
          if (savedId) {
            // Only after header + every item genuinely persisted -- never merely
            // because the dialog opened or the header POST alone returned. The
            // bank-payment review dialog is the reason this exists (it needs the
            // real DOCID to record its own outcome), but it's additive: nothing
            // about `done`'s existing callers changes.
            const savedDoc = doc.find(singleDoc => singleDoc && singleDoc.DOCID === savedId);
            this.documentSaved.emit({ documentId: savedId, doctype: savedDoc?.DOCTYPE ?? this.newDocument?.DOCTYPE });
          }

          if (this.agentRequestId) {
            if (savedId) {
              this.confirmAgentRequest(savedId);
            } else {
              // Never silent: a claimed request left open because nothing was saved is
              // exactly the state that went unnoticed before.
              console.warn(`*** CreateNewDocumentComponent onCreateDocument: agent request ${this.agentRequestId} not confirmed -- no document carries a DOCID after save`);
            }
          }
          if (this.navigateTo && docs === 1 && doc[0]) {
            this.router.navigate(['/edit-document', doc[0].DOCTYPE, doc[0].DOCID]);
          }
        },
        error: err => {
          console.error('*** CreateNewDocumentComponent onCreateDocument error:', err);
          this.done.emit(false);
          // A document can exist even though the chain failed -- the header POST succeeds
          // and one of its items then fails. Leaving the request claimed in that case is
          // what produced a resolved-looking document with an open request before.
          if (this.agentRequestId) {
            const savedId: number | null = savedDocumentId();
            if (savedId) { this.confirmAgentRequest(savedId); }
          }
        }
      });
  }

  /**
   * `PATCH /api/agent/requests/:id` with `outcome: 'approved'` and the just-created DOCID
   * -- fired right after `doSaveDocument()` completes for a document that originated from
   * the "AI Assist" tab. Fire-and-forget from the dialog's point of view: the WebYTO
   * document already exists and is not rolled back if this call fails, same as any other
   * post-save bookkeeping step. See `docs/PROMPT_agent-intake-confirmation-panel.md`.
   */
  private confirmAgentRequest(documentId: number): void {
    const requestId = this.agentRequestId;

    // Deliberately NOT piped through takeUntil(this.destroy$), unlike every other call in
    // this component.
    //
    // This fires from onCreateDocument()'s `complete`, and the `finalize` immediately
    // after it sets `display = false`. That closes the dialog, which emits displayChange,
    // and both hosts render this component under `*ngIf` on that same flag -- so the
    // component is destroyed within the same tick. With `navigateTo` set (the "Открыть
    // новый документ" checkbox, on by default) the router navigation tears the host down
    // as well. Either way destroy$ fired while the PATCH was still in flight and cancelled
    // it: the document was created, the request stayed `claimed`, and the dashboard went
    // on showing it as in_flight with no error anywhere.
    //
    // A one-shot HTTP call has nothing to leak -- it completes or fails on its own, and
    // its handlers touch no component state. Outcome logged either way so the next
    // occurrence is visible without guessing.
    this.agentDataApi.confirmRequest(requestId, 'approved', { documentId })
      .subscribe({
        next: () => {
          environment.production || console.log(`*** CreateNewDocumentComponent confirmAgentRequest: request ${requestId} -> approved, DOCID ${documentId}`);
          this.messageService.add({ severity: 'success', summary: `Звернення #${requestId} підтверджено` });
        },
        error: err => {
          console.error(`*** CreateNewDocumentComponent confirmAgentRequest error (request ${requestId}, DOCID ${documentId}):`, err);
          // Sticky: this toast is the only account of a request that stayed open
          // while its document was created, and the dialog closes on the same tick
          // it appears. A default 3-second toast on a closing dialog is gone before
          // it can be read, which is how this failure went undiagnosed twice.
          // Dismissed by hand, so nothing is lost while it is being read.
          //
          // The HTTP status is in the summary because it is the one fact that says
          // what to do next: 4xx means the PATCH was rejected and the body says
          // why, 0/504 means it never arrived, 5xx means the server broke.
          this.messageService.add({
            severity: 'error',
            sticky: true,
            summary: `Звернення #${requestId} НЕ підтверджено (HTTP ${err?.status ?? '—'})`,
            detail: `Документ ${documentId} створено, але звернення залишилось в роботі. `
              + (err?.error?.message || err?.message || 'Unknown error'),
          });
        },
      });
  }

  /**
   * Handles the "AI Assist" tab's `applyToDocument` event -- pre-fills `newDocument` from
   * the claimed request's resolution, then leaves the rest of the dialog (dates, company
   * confirmation via the existing `companyselector`-based components, item review) exactly
   * as every other document type already works. Does not create the document itself.
   */
  onApplyAgentRequest(seed: AgentDocumentSeed): void {
    environment.production || console.log('*** CreateNewDocumentComponent onApplyAgentRequest: ' + JSON.stringify(seed));

    const dddd = new Date();
    // `?.` on docTypes, not just on the result: this seed is fired from the AI Assist tab
    // as soon as the claimed request loads, which can beat `getDocTypes()` in ngOnInit.
    // A throw here would kill the whole seed silently and leave the panel with no blocks.
    const sgid = this.docTypes?.find(e => e.DOCTYPEID == seed.docType);
    const daysToValid = sgid?.DEFAULTVALTERM || (seed.docType === 12 ? 14 : 7);
    const daysToExpiry = sgid?.DEFAULTEXPTERM || (seed.docType === 12 ? 60 : 30);

    // Read before the rebuild below replaces newDocument. Only rows a person added are
    // carried: the AI's own proposals arrive fresh in `seed.items` on every re-seed, so
    // keeping the old copies too would duplicate every accepted candidate on a doc-type
    // switch.
    const carriedManualItems = this.carryOverItems(seed.docType).filter(row => !row.agentProposed);

    this.globalsettingsservice.getObservableGlobalSettings().pipe(
      filter(gs => gs ? true : false),
      take(1),
      concatMap(gs => {
        this.newDocument = {
          ...emptyDocument,
          ...{
            DOCID: -2,
            DOCACTIVE: 1,
            DOCTYPE: seed.docType,
            DOCCURRID: gs.balanceCurrencyId,
            DOCCLIENTSID: seed.customerId || null,
            // Both company fields get the resolved customer, mirroring exactly what
            // `new-document-dlg-companies`' own `cliCompanySelected()` does when a manager
            // picks a buyer by hand (it sets DOCCLIENTSID and DOCPCOCLIID together). It
            // also gives `fillInChildDocumentDepartmentAndPerson()` below a real company
            // to look up the partner department against, which it otherwise did with null.
            DOCPCOCLIID: seed.customerId || null,
            // The sender themselves. Both person selectors are scoped to the company
            // above, and this person belongs to it (they are the Person row whose
            // PERSCLIID *is* that company), so both are consistent.
            DOCPERSONID: seed.personId || null,
            DOCPCOPERID: seed.personId || null,
            DOCMANCLIID: gs.mainCompanyId,
            DOCMANPERID: gs.mainPersonId,
            DOCMANDEPID: gs.mainStockId,
            DOCLCOCLIID: seed.companyId || gs.defaultTradeCompanyId || gs.mainCompanyId,
            DOCLCOPERID: 0,
            DOCLCODEPID: 0,
            DOCNOTE1: '',
            DOCNOTE2: '',
            PRIMDOCID: null,
            DOCFLAG: 0,
            DOCDATE: dddd,
            DOCVALDATE: new Date(dddd.getFullYear(), dddd.getMonth(), dddd.getDate() + daysToValid),
            DOCEXPDATE: new Date(dddd.getFullYear(), dddd.getMonth(), dddd.getDate() + daysToExpiry),
            SGMGROUPID: sgid?.DOCSECGROUPID,
            items: [
              ...carriedManualItems,
              ...this.buildAgentDocItems(seed.items, seed.docType, gs.balanceCurrencyId, this.newDocument?.DOCRATEVAL || 1, carriedManualItems.length, this.maxRowSortIndex(carriedManualItems)),
            ],
          }
        };
        return of(this.newDocument);
      }),
      concatMap(ndi => this.fillInChildDocumentDepartmentAndPerson(ndi)),
      // AI-seeded rows arrive with no price -- POST /api/agent/resolve returns PRODID,
      // code and name, never pricing. Without this an AI-proposed product sat at 0 while
      // the identical product added by hand in the products panel came back priced.
      // Runs after the header is complete, since pricing reads DOCMANCLIID/DOCCURRID/
      // DOCRATEVAL off it.
      concatMap(ndi => this.pricing.priceMissingRows(ndi).pipe(toArray(), map(() => ndi))),
      map(ndi => {
        // That step overwrites DOCPCOPERID unconditionally, with whichever contact at the
        // company carries PERSRESPONSIBLE (or simply the first one) -- the right default
        // when nothing better is known, but here something better *is* known: the person
        // who actually sent the email. Re-applied after, not instead, so every other
        // field that step fills in (departments, our own side's person) is untouched.
        // Skipped when the agent could not identify an individual, which leaves that
        // step's own choice standing.
        if (seed.personId) {
          ndi.DOCPCOPERID = seed.personId;
        }
        return ndi;
      }),
      // Bug fix: Fill DOCPERSONID (buyer's contact) when not identified by exact email.
      // Scoped to the AI Assist path only -- do not modify fillInChildDocumentDepartmentAndPerson
      // which has ~20 other call sites.
      concatMap(ndi => {
        if (ndi.DOCPERSONID) {
          return of(ndi);
        }
        if (!ndi.DOCCLIENTSID) {
          return of(ndi);
        }
        return this.cliApi.getPersonsByClientId(ndi.DOCCLIENTSID).pipe(
          map(prs => {
            const dir: Person = prs.sort((a, b) => (b.PERSRESPONSIBLE - a.PERSRESPONSIBLE)).find(pr => pr.PERSRESPONSIBLE > 0);
            if (dir) {
              ndi.DOCPERSONID = dir.PERSID;
            } else if (prs.length > 0) {
              ndi.DOCPERSONID = prs[0].PERSID;
            }
            return ndi;
          })
        );
      }),
      finalize(() => { this._finalizeDocumentCreation(seed.docType === 1 ? 2 : 1); })
    ).subscribe();
  }

  /**
   * Handles the "AI Assist" tab's `itemsChange` -- the manager accepted or dropped a catalog
   * candidate for an already-seeded document. Replaces `newDocument.items` only, leaving
   * every header field untouched: re-running the full seed here would rebuild `newDocument`
   * from `emptyDocument` and throw away a counterparty or date the manager had just fixed by
   * hand in the blocks below.
   */
  onAgentItemsChange(items: AgentDocumentSeed['items']): void {
    environment.production || console.log('*** CreateNewDocumentComponent onAgentItemsChange: ' + JSON.stringify(items));

    if (!this.newDocument) { return; }

    // Merge, not replace. This used to overwrite `items` outright, which was harmless
    // while the AI panel was the only thing that could put a row there. It stopped being
    // harmless the moment the products panel let a manager add rows by hand: accepting
    // one more catalogue candidate would silently drop every one of them.
    //
    // The AI owns exactly the rows it proposed, keyed by PRODID -- those are rebuilt from
    // the incoming list. Anything else in the document was put there by a person and is
    // left strictly alone, including their edits to quantity and price on an AI-proposed
    // row that is still accepted.
    const incomingByProdId = new Map(items.map(i => [i.prodId, i]));
    const existing = this.newDocument.items ?? [];

    const kept = existing.filter(row => !row.agentProposed || incomingByProdId.has(row.PRODID));
    for (const row of kept) {
      if (row.agentProposed) {
        incomingByProdId.delete(row.PRODID);
      }
    }

    const added = this.buildAgentDocItems(
      [...incomingByProdId.values()],
      this.newDocument.DOCTYPE,
      this.newDocument.DOCCURRID,
      this.newDocument.DOCRATEVAL || 1,
      kept.length,
      this.maxRowSortIndex(kept)
    );

    this.newDocument.items = [...kept, ...added];

    // Newly accepted candidates come in unpriced; rows already carrying a price -- including
    // any the manager corrected by hand -- are left untouched by priceMissingRows().
    this.pricing.priceMissingRows(this.newDocument)
      .pipe(takeUntil(this.destroy$))
      .subscribe();
  }

  /**
   * Products already entered on the current unsaved document, re-tagged for the type
   * about to replace it.
   *
   * Every `onCreateXxx` handler rebuilds `newDocument` from `emptyDocument`, which was
   * harmless while nothing could be entered before creation. With the products panel it
   * is not: clicking "Выставить счет" after building up a КП would silently discard the
   * lot. Switching type is a change of document *kind*, not an instruction to throw away
   * what the manager already picked.
   *
   * Deliberately limited to the proforma <-> invoice pair (12 <-> 1). They share an item
   * shape and are the two types the products panel serves; a receipt, purchase order or
   * transaction means something different by a line item, so those handlers keep starting
   * empty. `DOCID` is cleared along with the re-tag -- these rows belong to no saved
   * document yet, and their negative `DOCITEMID`s stay valid as temporary keys.
   */
  private carryOverItems(nextDocType: number): DocItems[] {
    const existing = this.newDocument?.items ?? [];
    if (existing.length === 0) { return []; }
    if (![1, 12].includes(nextDocType)) { return []; }
    if (!this.newDocument || ![1, 12].includes(this.newDocument.DOCTYPE)) { return []; }

    environment.production || console.log(`*** CreateNewDocumentComponent carryOverItems: ${existing.length} row(s) -> DOCTYPE ${nextDocType}`);

    return existing.map((item): DocItems => ({ ...item, DOCTYPE: nextDocType, DOCID: null }));
  }

  /** Highest PAYITEMCLIID (row sort order) among the given rows; 0 when none carries one. */
  private maxRowSortIndex(rows: DocItems[]): number {
    return rows.reduce((max, r) => Math.max(max, Number(r.PAYITEMCLIID) || 0), 0);
  }

  /**
   * Maps AI-resolved catalog picks to `DocItems` rows.
   * Price/currency deliberately left at 0 -- the AI-resolved candidate only carries
   * PRODID/name/code (see POST /api/agent/resolve), never pricing. The manager fills those
   * in the same way as any manually-added item, via the edit-document page after creation
   * (see the design doc's note on this).
   */
  private buildAgentDocItems(
    items: AgentDocumentSeed['items'],
    docType: number,
    currId: number,
    rate: number,
    idOffset: number = 0,
    startRowIndex: number = 0,
  ): DocItems[] {
    return items.map((item, index): DocItems => ({
      // Offset so rows appended alongside hand-added ones cannot collide on the temporary
      // id. Real DOCITEMIDs are assigned by the API on POST; these only need to be unique
      // within the unsaved document.
      DOCITEMID: -2 - idOffset - index,
      // Marks the row as the AI's, so a later itemsChange can rebuild its own proposals
      // without touching rows a person added. Not persisted -- DocItems carries it only
      // in memory, and doSaveDocument() posts named fields, not the whole object.
      agentProposed: true,
      DOCID: null,
      DOCTYPE: docType,
      PRODID: item.prodId,
      PRODCODE: item.prodCode,
      DOCITEMPRODNAME: item.prodName,
      DOCITEMPRICE: 0,
      DOCITEMQTY: item.qty,
      DOCITEMVPRICE: 0,
      DOCITEMCURRID: currId,
      // The document's own rate, not a hard-coded 1. DocItemPricingService overwrites this
      // when it prices the row, but a row whose pricing fails still has to agree with the
      // document header -- edit-document-content flags `DOCITEMCRATE != DOCRATEVAL` as
      // "Курс не соответствует установленному в документе".
      DOCITEMCRATE: rate,
      // Row sort order, same running convention as the other document-creation paths
      // (step of 10, continuing after any rows already on the document).
      PAYITEMCLIID: startRowIndex + (index + 1) * 10,
      PAYITEMDEPID: null,
      DOCITEMTEXT1: '',
      DOCITEMTEXT2: '',
      CURCODE: '',
      U4ETKA: null,
    }));
  }

  /** Handles the "AI Assist" tab's `abandoned` event -- the request is already marked
   *  `rejected` server-side by the time this fires; nothing here creates or touches a
   *  WebYTO document, so closing the dialog is the whole job. */
  onAgentRequestAbandoned(): void {
    this.display = false;
  }

  /**
   * Fills in the local-company and partner-company department/person IDs on `doc` by querying
   * child departments and responsible persons from the API.
   * Used by all `onCreateXxx` handlers before the document is shown to the user.
   * Fallback: if no child department exists, the parent department ID is used (known limitation).
   */
  fillInChildDocumentDepartmentAndPerson(doc: Document): Observable<Document> {
    return this.bankPaymentDocs.fillInChildDocumentDepartmentAndPerson(doc);
  }

  onCreateProforma(event) {
    environment.production || console.log('*** CreateNewDocumentComponent onCreateProforma 1');
    const dddd = new Date();

    const sgid = this.docTypes.find(e => e.DOCTYPEID == 12);              // Actually it does not need, database trigger do it on DB level
                                                                        // Actually-2: we need it to get the validity and expiry terms
    const daysToValid = sgid.DEFAULTVALTERM || 14;
    const daysToExpiry = sgid.DEFAULTEXPTERM || 60;

    // Read before the rebuild below replaces newDocument.
    const carriedItems = this.carryOverItems(12);


      this.globalsettingsservice.getObservableGlobalSettings().pipe(

        filter(gs => gs ? true : false),
        take(1),
        concatMap(gs => {
          environment.production || console.log('*** CreateNewDocumentComponent onCreateProforma 2a');

          this.newDocument = {
            ...emptyDocument,
            ...{
              DOCID: -2,
              DOCACTIVE: 1,
              DOCTYPE: 12,
              DOCCURRID: gs.balanceCurrencyId,
              DOCMANCLIID: gs.mainCompanyId,
              DOCMANPERID: gs.mainPersonId,
              DOCMANDEPID: gs.mainStockId,
              DOCLCOCLIID: gs.defaultTradeCompanyId || gs.mainCompanyId,
              DOCLCOPERID: 0,
              DOCLCODEPID: 0,
              DOCNOTE1: '',
              DOCNOTE2: '',
              PRIMDOCID: null,
              DOCFLAG: 0,
              DOCDATE: dddd,
              DOCVALDATE: new Date(dddd.getFullYear(), dddd.getMonth(), dddd.getDate() + daysToValid),   // Price and condition are valid 30 days
              DOCEXPDATE: new Date(dddd.getFullYear(), dddd.getMonth(), dddd.getDate() + daysToExpiry),   // All items will be supplied in 60 days

              SGMGROUPID: sgid.DOCSECGROUPID,
              items: carriedItems
            }
          };
          return of(this.newDocument);
        }),

        concatMap(ndi => this.fillInChildDocumentDepartmentAndPerson(ndi)),

        finalize(() => { this._finalizeDocumentCreation(1); })
      ).subscribe()
  }

  onCreateChildProforma(event) {
    environment.production || console.log('*** CreateNewDocumentComponent onCreateChildProforma  ');
    const dddd = new Date();

    if (this.parentDocument) {
      environment.production || console.log('*** CreateNewDocumentComponent onCreateChildProforma parentDocument: ' + JSON.stringify(this.parentDocument));

      // Actually-2: we need it to get the validity and expiry terms
      const sgid = this.docTypes.find(e => e.DOCTYPEID == 1);

      const daysToValid = sgid.DEFAULTVALTERM || 14;
      const daysToExpiry = sgid.DEFAULTEXPTERM || 60;

          this.globalsettingsservice.getObservableGlobalSettings().pipe(

          filter(gs => gs ? true : false),
          take(1),
          concatMap(gs => {
            environment.production || console.log('*** CreateNewDocumentComponent onCreateChildProforma 2a');

            this.newDocument = {
              ... this.selectedDocument ?? {
                ...emptyDocument,
                ...{
                  DOCID: -2,
                  DOCACTIVE: 1,
                  DOCTYPE: 12,
                  DOCCURRID: this.parentDocument.DOCCURRID,
                  DOCCLIENTSID: this.parentDocument.DOCCLIENTSID,
                  DOCPERSONID: this.parentDocument.DOCPERSONID,
                  DOCCLIDEPID: this.parentDocument.DOCCLIDEPID,
                  DOCPCOCLIID: this.parentDocument.DOCPCOCLIID,
                  DOCPCOPERID: this.parentDocument.DOCPCOPERID,
                  DOCPCODEPID: this.parentDocument.DOCPCODEPID,

                  DOCMANCLIID: gs.mainCompanyId,
                  DOCMANPERID: gs.mainPersonId,
                  DOCMANDEPID: this.parentDocument.DOCMANDEPID,
                  DOCLCOCLIID: this.parentDocument.DOCLCOCLIID,
                  DOCLCOPERID: this.parentDocument.DOCLCOPERID,

                  DOCNOTE1: this.parentDocument.DOCNOTE1,
                  DOCNOTE2: this.parentDocument.DOCNOTE2,
                  PRIMDOCID: this.parentDocument.DOCID,
                  DOCFLAG: 0,
                  DOCDATE: dddd,
                  DOCVALDATE: new Date(dddd.getFullYear(), dddd.getMonth(), dddd.getDate() + daysToValid),   // Price and condition are valid 30 days
                  DOCEXPDATE: new Date(dddd.getFullYear(), dddd.getMonth(), dddd.getDate() + daysToExpiry),   // All items will be supplied in 60 days

                  SGMGROUPID: this.parentDocument.SGMGROUPID,
                }
              }
            };

            return of(this.newDocument);
          }),

          concatMap(ndi => this.fillInChildDocumentDepartmentAndPerson(ndi)),

          finalize(() => { this._finalizeDocumentCreation(1); })
        ).subscribe()
    }
  }

  onCreateInvoice(event) {
    environment.production || console.log('*** CreateNewDocumentComponent onCreateInvoice  ');
    const dddd = new Date();
    const sgid = this.docTypes.find(e => e.DOCTYPEID == 1);

    const daysToValid = sgid.DEFAULTVALTERM || 7;
    const daysToExpiry = sgid.DEFAULTEXPTERM || 30;

    // Read before the rebuild below replaces newDocument.
    const carriedItems = this.carryOverItems(1);

      this.globalsettingsservice.getObservableGlobalSettings().pipe(

        filter(gs => gs ? true : false),
        take(1),
        concatMap(gs => {
          environment.production || console.log('*** CreateNewDocumentComponent onCreateInvoice 2a');

          this.newDocument = {
            ...emptyDocument,
            ...{
              DOCID: -2,
              DOCACTIVE: 1,
              DOCTYPE: 1,
              DOCCURRID: gs.balanceCurrencyId,
              DOCMANCLIID: gs.mainCompanyId,
              DOCMANPERID: gs.mainPersonId,
              DOCMANDEPID: gs.mainStockId,
              DOCLCOCLIID: gs.defaultTradeCompanyId || gs.mainCompanyId,
              DOCLCOPERID: 0,
              DOCLCODEPID: 0,
              DOCNOTE1: '',
              DOCNOTE2: '',
              PRIMDOCID: null,
              DOCFLAG: 0,
              DOCDATE: dddd,
              DOCVALDATE: new Date(dddd.getFullYear(), dddd.getMonth(), dddd.getDate() + daysToValid),   // Price and condition are valid 7 days
              DOCEXPDATE: new Date(dddd.getFullYear(), dddd.getMonth(), dddd.getDate() + daysToExpiry),   // All items will be supplied in 30 days

              SGMGROUPID: sgid.DOCSECGROUPID,
              items: carriedItems
            }
          };
          return of(this.newDocument);
        }),

        concatMap(ndi => this.fillInChildDocumentDepartmentAndPerson(ndi)),

        finalize(() => { this._finalizeDocumentCreation(2); })
      ).subscribe()
  }

  onCreateChildInvoice(event) {
    environment.production || console.log('*** CreateNewDocumentComponent onCreateChildInvoice  ');
    const dddd = new Date();

    const sgid = this.docTypes.find(e => e.DOCTYPEID == 1);

    const daysToValid = sgid.DEFAULTVALTERM || 7;
    const daysToExpiry = sgid.DEFAULTEXPTERM || 30;

    if (this.parentDocument) {
      environment.production || console.log('*** CreateNewDocumentComponent onCreateChildInvoice parentDocument: ' + JSON.stringify(this.parentDocument));
      environment.production || console.log('*** CreateNewDocumentComponent onCreateChildInvoice selectedDocument: ' + JSON.stringify(this.selectedDocument));

          this.globalsettingsservice.getObservableGlobalSettings().pipe(

          filter(gs => gs ? true : false),
          take(1),
          concatMap(gs => {
            environment.production || console.log('*** CreateNewDocumentComponent onCreateChildInvoice 2a');

            this.newDocument = {
              ... this.selectedDocument ?? {
                ...emptyDocument,
                ...{
                  DOCID: -2,
                  DOCACTIVE: 1,
                  DOCTYPE: 1,
                  DOCCURRID: this.parentDocument.DOCCURRID,
                  DOCCLIENTSID: this.parentDocument.DOCCLIENTSID,
                  DOCPERSONID: this.parentDocument.DOCPERSONID,
                  DOCCLIDEPID: this.parentDocument.DOCCLIDEPID,
                  DOCPCOCLIID: this.parentDocument.DOCPCOCLIID,
                  DOCPCODEPID: this.parentDocument.DOCPCODEPID,
                  DOCPCOPERID: this.parentDocument.DOCPCOPERID,

                  DOCMANCLIID: gs.mainCompanyId,
                  DOCMANPERID: gs.mainPersonId,
                  DOCMANDEPID: this.parentDocument.DOCMANDEPID,
                  DOCLCOCLIID: this.parentDocument.DOCLCOCLIID,
                  DOCLCOPERID: this.parentDocument.DOCLCOPERID,
                  DOCLCODEPID: this.parentDocument.DOCLCODEPID,

                  DOCNOTE1: this.parentDocument.DOCNOTE1,
                  DOCNOTE2: this.parentDocument.DOCNOTE2,
                  PRIMDOCID: this.parentDocument.DOCID,
                  DOCFLAG: 0,
                  DOCDATE: dddd,
                  DOCVALDATE: new Date(dddd.getFullYear(), dddd.getMonth(), dddd.getDate() + daysToValid),   // Price and condition are valid 7 days
                  DOCEXPDATE: new Date(dddd.getFullYear(), dddd.getMonth(), dddd.getDate() + daysToExpiry),   // All items will be supplied in 30 days

                  SGMGROUPID: this.parentDocument.SGMGROUPID,
                }
              }
            };

            return of(this.newDocument);
          }),

          concatMap(ndi => this.fillInChildDocumentDepartmentAndPerson(ndi)),

          finalize(() => { this._finalizeDocumentCreation(2); })
        ).subscribe()
    }
  }

  onCreateIncomeReceipt(event) {
    environment.production || console.log('*** CreateNewDocumentComponent onCreateIncomeReceipt  ');

    const dddd = new Date();
    const sgid = this.docTypes.find(e => e.DOCTYPEID == 2);

    const defaultLocalCompany = this.globalsettingsservice.getGlobalSettings().defaultTradeCompanyId || this.globalsettingsservice.getMainCompanyId();

    this.newDocument = {
      ...emptyDocument,
      ...{
        DOCID: -2,
        DOCACTIVE: 1,
        DOCTYPE: 2,
        DOCCURRID: this.globalsettingsservice.getBalanceCurrencyId(),
        DOCRATEVAL: 0,
        DOCMANCLIID: this.globalsettingsservice.getMainCompanyId(),
        DOCMANPERID: this.globalsettingsservice.getGlobalSettings().mainPersonId,
        DOCMANDEPID: this.globalsettingsservice.getGlobalSettings().mainStockId,
        DOCLCOCLIID: defaultLocalCompany,
        DOCLCOPERID: 0,
        DOCLCODEPID: 0,
        DOCNOTE1: '',
        DOCNOTE2: '',
        PRIMDOCID: null,
        DOCFLAG: 0,
        DOCDATE: dddd,
        DOCVALDATE: new Date(dddd.getFullYear(), dddd.getMonth(), dddd.getDate()),
        DOCEXPDATE: new Date(dddd.getFullYear(), dddd.getMonth(), dddd.getDate()),

        SGMGROUPID: sgid.DOCSECGROUPID,
        items: []

      }
    };

      of(this.newDocument)
        .pipe(
          concatMap(ndi => this.fillInChildDocumentDepartmentAndPerson(ndi)),

          finalize(() => { this._finalizeDocumentCreation(3); })
        )
        .subscribe();
  }

  onCreateChildIncomeReceipt(event) {
    environment.production || console.log('*** CreateNewDocumentComponent onCreateChildIncomeReceipt');

    const dddd = new Date();

    if (this.parentDocument) {
      environment.production || console.log('*** CreateNewDocumentComponent onCreateChildIncomeReceipt parentDocument: ' + JSON.stringify(this.parentDocument));
      environment.production || console.log('*** CreateNewDocumentComponent onCreateChildIncomeReceipt selectedDocument: ' + JSON.stringify(this.selectedDocument));

      this.newDocument = {
        ... this.selectedDocument ?? {
          ...emptyDocument,
          ...{
            DOCID: -2,
            DOCACTIVE: 1,
            DOCTYPE: 2,
            DOCCURRID: this.parentDocument.DOCCURRID,
            DOCCLIENTSID: this.parentDocument.DOCCLIENTSID,
            DOCPERSONID: this.parentDocument.DOCPERSONID,
            DOCCLIDEPID: this.parentDocument.DOCCLIDEPID,
            DOCPCOCLIID: this.parentDocument.DOCPCOCLIID,
            DOCPCODEPID: this.parentDocument.DOCPCODEPID,
            DOCPCOPERID: this.parentDocument.DOCPCOPERID,

            DOCMANCLIID: this.globalsettingsservice.getMainCompanyId(),
            DOCMANPERID: this.globalsettingsservice.getGlobalSettings().mainPersonId,
            DOCMANDEPID: this.parentDocument.DOCMANDEPID,
            DOCLCOCLIID: this.parentDocument.DOCLCOCLIID,
            DOCLCOPERID: this.parentDocument.DOCLCOPERID,
            DOCLCODEPID: this.parentDocument.DOCLCODEPID,

            DOCNOTE1: this.parentDocument.DOCNOTE1,
            DOCNOTE2: this.parentDocument.DOCNOTE2,
            PRIMDOCID: this.parentDocument.DOCID,
            DOCFLAG: 0,
            DOCDATE: dddd,
            DOCVALDATE: new Date(dddd.getFullYear(), dddd.getMonth(), dddd.getDate() + 7),   // Price and condition are valid 7 days
            DOCEXPDATE: new Date(dddd.getFullYear(), dddd.getMonth(), dddd.getDate() + 30),   // All items will be supplied in 30 days

            SGMGROUPID: this.parentDocument.SGMGROUPID,
          }
        }
      };

          of(this.newDocument)
          .pipe(
            concatMap(ndi => this.fillInChildDocumentDepartmentAndPerson(ndi)),

            finalize(() => { this._finalizeDocumentCreation(3); })
          )
          .subscribe();
    }
  }

  onCreatePurchaseOrder(event) {
    environment.production || console.log('*** CreateNewDocumentComponent onCreatePurchaseOrder  ');

    const dddd = new Date();
    const sgid = this.docTypes.find(e => e.DOCTYPEID == 10);

    const defaultLocalCompany = this.globalsettingsservice.getGlobalSettings().defaultTradeCompanyId || this.globalsettingsservice.getMainCompanyId();

    this.newDocument = {
      ...emptyDocument,
      ...{
        DOCID: -2,
        DOCACTIVE: 1,
        DOCTYPE: 10,
        DOCCURRID: this.globalsettingsservice.getBalanceCurrencyId(),
        DOCRATEVAL: 0,
        DOCMANCLIID: this.globalsettingsservice.getMainCompanyId(),
        DOCMANPERID: this.globalsettingsservice.getGlobalSettings().mainPersonId,
        DOCMANDEPID: this.globalsettingsservice.getGlobalSettings().mainStockId,
        DOCLCOCLIID: defaultLocalCompany,
        DOCLCOPERID: 0,
        DOCLCODEPID: 0,
        DOCNOTE1: '',
        DOCNOTE2: '',
        PRIMDOCID: null,
        DOCFLAG: 0,
        DOCDATE: dddd,
        DOCVALDATE: new Date(dddd.getFullYear(), dddd.getMonth(), dddd.getDate() + 7),   // Price and condition are valid 7 days
        DOCEXPDATE: new Date(dddd.getFullYear(), dddd.getMonth(), dddd.getDate() + 30),   // All items will be supplied in 30 days

        SGMGROUPID: sgid.DOCSECGROUPID,
        items: []
      }
    };

      of(this.newDocument)
        .pipe(
          concatMap(ndi => this.fillInChildDocumentDepartmentAndPerson(ndi)),

          finalize(() => { this._finalizeDocumentCreation(7); })
        )
        .subscribe();
  }

  onCreateChildPurchOrder(event) {
    environment.production || console.log('*** CreateNewDocumentComponent onCreateChildPurchOrder');

    const dddd = new Date();

    if (this.parentDocument) {
      environment.production || console.log('*** CreateNewDocumentComponent onCreateChildPurchOrder parentDocument: ' + JSON.stringify(this.parentDocument));
      environment.production || console.log('*** CreateNewDocumentComponent onCreateChildPurchOrder selectedDocument: ' + JSON.stringify(this.selectedDocument));
      this.newDocument = {
        ... this.selectedDocument ?? {
          ...emptyDocument,
          ...{
            DOCID: -2,
            DOCACTIVE: 1,
            DOCTYPE: 10,
            DOCCURRID: this.parentDocument.DOCCURRID,
            DOCCLIENTSID: this.parentDocument.DOCCLIENTSID,
            DOCPERSONID: this.parentDocument.DOCPERSONID,
            DOCCLIDEPID: this.parentDocument.DOCCLIDEPID,
            DOCPCOCLIID: this.parentDocument.DOCPCOCLIID,
            DOCPCODEPID: this.parentDocument.DOCPCODEPID,
            DOCPCOPERID: this.parentDocument.DOCPCOPERID,

            DOCMANCLIID: this.globalsettingsservice.getMainCompanyId(),
            DOCMANPERID: this.globalsettingsservice.getGlobalSettings().mainPersonId,
            DOCMANDEPID: this.parentDocument.DOCMANDEPID,
            DOCLCOCLIID: this.parentDocument.DOCLCOCLIID,
            DOCLCOPERID: this.parentDocument.DOCLCOPERID,
            DOCLCODEPID: this.parentDocument.DOCLCODEPID,

            DOCNOTE1: this.parentDocument.DOCNOTE1,
            DOCNOTE2: this.parentDocument.DOCNOTE2,
            PRIMDOCID: this.parentDocument.DOCID,
            DOCFLAG: 0,
            DOCDATE: dddd,
            DOCVALDATE: new Date(dddd.getFullYear(), dddd.getMonth(), dddd.getDate() + 7),   // Price and condition are valid 7 days
            DOCEXPDATE: new Date(dddd.getFullYear(), dddd.getMonth(), dddd.getDate() + 30),   // All items will be supplied in 30 days

            SGMGROUPID: this.parentDocument.SGMGROUPID,
          }
        }
      };

          of(this.newDocument)
          .pipe(
            concatMap(ndi => this.fillInChildDocumentDepartmentAndPerson(ndi)),

            finalize(() => { this._finalizeDocumentCreation(7); })
          )
          .subscribe();

      environment.production || console.log('*** CreateNewDocumentComponent onCreateChildPurchOrder  3: ' + JSON.stringify(this.newDocument));
    }
  }

  onCreateInventorySheet(event) {
    environment.production || console.log('*** CreateNewDocumentComponent onCreateInventorySheet');

    const dddd = new Date();
    const sgid = this.docTypes.find(e => e.DOCTYPEID == 14);

    const defaultLocalCompany = this.globalsettingsservice.getGlobalSettings().defaultTradeCompanyId || this.globalsettingsservice.getMainCompanyId();

      of(this.selectedDocument)
        .pipe(
          map(d => {

            this.newDocument = {
              ...d ?? {
                ...emptyDocument,
                ...{
                  DOCID: -2,
                  DOCACTIVE: 1,
                  DOCTYPE: 14,
                  DOCCURRID: this.globalsettingsservice.getBalanceCurrencyId(),

                  DOCCLIENTSID: this.globalsettingsservice.getMainCompanyId(),
                  DOCPERSONID: this.globalsettingsservice.getGlobalSettings().mainPersonId,
                  DOCCLIDEPID: this.globalsettingsservice.getGlobalSettings().mainStockId,

                  DOCPCOCLIID: defaultLocalCompany,

                  DOCMANCLIID: this.globalsettingsservice.getMainCompanyId(),
                  DOCMANPERID: this.globalsettingsservice.getGlobalSettings().mainPersonId,
                  DOCMANDEPID: this.globalsettingsservice.getGlobalSettings().mainStockId,

                  DOCLCOCLIID: defaultLocalCompany,

                  DOCNOTE1: null,
                  DOCNOTE2: null,
                  PRIMDOCID: null,
                  DOCFLAG: 0,
                  DOCDATE: dddd,
                  DOCVALDATE: dddd,
                  DOCEXPDATE: dddd,

                  items: [],

                  SGMGROUPID: sgid.DOCSECGROUPID,
                }
              }
            };
            return this.newDocument;
          }),

          concatMap(ndi => this.fillInChildDocumentDepartmentAndPerson(ndi)),

          finalize(() => { this._finalizeDocumentCreation(10); })
        )
      .subscribe();
  }

  onCreateChildShipment(event) {
    environment.production || console.log('*** CreateNewDocumentComponent onCreateChildShipment ');

    const dddd = new Date();

    if (this.parentDocument) {
      environment.production || console.log('*** CreateNewDocumentComponent onCreateChildShipment parentDocument: ' + JSON.stringify(this.parentDocument));
      environment.production || console.log('*** CreateNewDocumentComponent onCreateChildShipment selectedDocument: ' + JSON.stringify(this.selectedDocument));

          of(this.selectedDocument)
          .pipe(
            map(d => {

              this.newDocument = {
                ... this.selectedDocument ?? {
                  ...emptyDocument,
                  ...{
                    DOCID: -2,
                    DOCACTIVE: 1,
                    DOCTYPE: 4,
                    DOCCURRID: this.parentDocument.DOCCURRID,
                    DOCCLIENTSID: this.parentDocument.DOCCLIENTSID,
                    DOCPERSONID: this.parentDocument.DOCPERSONID,
                    DOCCLIDEPID: this.parentDocument.DOCCLIDEPID,

                    DOCPCOCLIID: this.parentDocument.DOCPCOCLIID,
                    DOCPCODEPID: this.parentDocument.DOCPCODEPID,
                    DOCPCOPERID: this.parentDocument.DOCPCOPERID,

                    DOCMANCLIID: this.globalsettingsservice.getMainCompanyId(),
                    DOCMANPERID: this.globalsettingsservice.getGlobalSettings().mainPersonId,
                    DOCMANDEPID: this.parentDocument.DOCMANDEPID,
                    DOCLCOCLIID: this.parentDocument.DOCLCOCLIID,
                    DOCLCOPERID: this.parentDocument.DOCLCOPERID,
                    DOCLCODEPID: this.parentDocument.DOCLCODEPID,

                    DOCNOTE1: this.parentDocument.DOCNOTE1,
                    DOCNOTE2: this.parentDocument.DOCNOTE2,
                    PRIMDOCID: this.parentDocument.DOCID,
                    DOCFLAG: 0,
                    DOCDATE: dddd,
                    DOCVALDATE: dddd,
                    DOCEXPDATE: dddd,

                    SGMGROUPID: this.parentDocument.SGMGROUPID,
                  }
                }
              };

              return this.newDocument;
            }),

            concatMap(ndi => this.fillInChildDocumentDepartmentAndPerson(ndi)),

            finalize(() => { this._finalizeDocumentCreation(4); })
          )
          .subscribe();
    }
  }

  onCreateChildPayment(event) {
    environment.production || console.log('*** CreateNewDocumentComponent onCreateChildPayment  ' + JSON.stringify(this.parentDocument));
    const dddd = new Date();
    const sgid = this.docTypes.find(e => e.DOCTYPEID == 9);

    if (this.parentDocument) {

          of(this.selectedDocument)
          .pipe(
            map(d => {

              // Construction lives in BankPaymentDocumentService so the bank review
              // panel's auto-create builds byte-for-byte the same payment. Build only:
              // nothing is saved until the manager presses Save (onCreateDocument()).
              this.newDocument = {
                ...d ?? this.bankPaymentDocs.buildChildPaymentDocument(this.parentDocument, this.bankPaymentSeed, sgid.DOCSECGROUPID)
              };
              return this.newDocument;
            }),

            concatMap(ndi => this.fillInChildDocumentDepartmentAndPerson(ndi)),

            finalize(() => { this._finalizeDocumentCreation(9, false); })
          )
          .subscribe();
    }
  }

  onCreateTransaction(event) {
    environment.production || console.log('*** CreateNewDocumentComponent onCreateTransaction  ');

    const dddd = new Date();
    const sgid = this.docTypes.find(e => e.DOCTYPEID == 5);

      this.globalsettingsservice.getObservableGlobalSettings().pipe(

        filter(gs => gs ? true : false),
        take(1),
        concatMap(gs => {
          environment.production || console.log('*** CreateNewDocumentComponent onCreateTransaction 2a');

          this.newDocument = {
            ...emptyDocument,
            ...{
              DOCID: -2,
              DOCACTIVE: 1,
              DOCTYPE: 5,
              DOCCURRID: gs.balanceCurrencyId,

              DOCCLIENTSID: gs.mainCompanyId,
              DOCPERSONID: gs.mainPersonId,
              DOCCLIDEPID: gs.mainStockId,

              DOCPCOCLIID: gs.defaultTradeCompanyId || gs.mainCompanyId,

              DOCMANCLIID: gs.mainCompanyId,
              DOCMANPERID: gs.mainPersonId,
              DOCMANDEPID: gs.mainStockId,
              DOCLCOCLIID: gs.defaultTradeCompanyId || gs.mainCompanyId,

              DOCNOTE1: null,
              DOCNOTE2: null,
              PRIMDOCID: null,
              DOCFLAG: 0,
              DOCDATE: dddd,
              DOCVALDATE: dddd,
              DOCEXPDATE: dddd,

              SGMGROUPID: sgid.DOCSECGROUPID,
              items: [],
            }
          };
          return of(this.newDocument);
        }),

        concatMap(ndi => this.fillInChildDocumentDepartmentAndPerson(ndi)),

        finalize(() => {
          this._finalizeDocumentCreation(5);
          this.openDateAndCurrencyTab = true;
          this.openRecipientTab = true;
          this.openTransactionDetailTab = true;
          this.manProcessEnded = false;
        })
      ).subscribe();
  }

  onCreateChildTransaction(event) {
    environment.production || console.log('*** CreateNewDocumentComponent onCreateChildTransaction  ');

    const dddd = new Date();
    const sgid = this.docTypes.find(e => e.DOCTYPEID == 5);

    const defaultLocalCompany =
      (this.selectedDocument) ?
          (this.selectedDocument.DOCLCOCLIID ?? this.selectedDocument.DOCMANCLIID) :
            (this.parentDocument) ? (this.parentDocument.DOCLCOCLIID ?? this.parentDocument.DOCMANCLIID) :
              (this.globalsettingsservice.getGlobalSettings().defaultTradeCompanyId ?? this.globalsettingsservice.getMainCompanyId());

      of(this.selectedDocument)
        .pipe(
          map(d => {

            this.newDocument = {
              ...d ?? {
                ...emptyDocument,
                ...{
                  DOCID: -2,
                  DOCACTIVE: 1,
                  DOCTYPE: 5,
                  DOCCURRID: this.parentDocument.DOCCURRID,

                  DOCCLIENTSID: this.parentDocument.DOCMANCLIID ?? this.globalsettingsservice.getMainCompanyId(),
                  DOCPERSONID: this.globalsettingsservice.getGlobalSettings().mainPersonId,
                  DOCCLIDEPID: this.parentDocument.DOCMANDEPID ?? this.globalsettingsservice.getGlobalSettings().mainStockId,

                  DOCPCOCLIID: defaultLocalCompany,

                  DOCMANCLIID: this.parentDocument.DOCMANCLIID ?? this.globalsettingsservice.getMainCompanyId(),
                  DOCMANPERID: this.globalsettingsservice.getGlobalSettings().mainPersonId,
                  DOCMANDEPID: this.parentDocument.DOCMANDEPID ?? this.globalsettingsservice.getGlobalSettings().mainStockId,

                  DOCLCOCLIID: defaultLocalCompany,

                  DOCNOTE1: this.parentDocument.DOCNOTE1,
                  DOCNOTE2: this.parentDocument.DOCNOTE2,
                  PRIMDOCID: this.parentDocument.DOCID,
                  DOCFLAG: 0,
                  DOCDATE: dddd,
                  DOCVALDATE: dddd,
                  DOCEXPDATE: dddd,

                  items: [],

                  SGMGROUPID: sgid.DOCSECGROUPID,
                }
              },
              ...{
                DOCCLIENTSID: this.parentDocument.DOCMANCLIID ?? this.globalsettingsservice.getMainCompanyId(),
                DOCPCOCLIID: defaultLocalCompany,
                DOCMANCLIID: this.parentDocument.DOCMANCLIID ?? this.globalsettingsservice.getMainCompanyId(),
                DOCLCOCLIID: defaultLocalCompany,
              }
            };
            environment.production || console.log('*** CreateNewDocumentComponent onCreateChildTransaction 3: ' + JSON.stringify(this.newDocument));
            return this.newDocument;
          }),

          concatMap(ndi => this.fillInChildDocumentDepartmentAndPerson(ndi)),

          finalize(() => {
            this._finalizeDocumentCreation(5);
            this.openDateAndCurrencyTab = false;
            this.openRecipientTab = false;
            this.openTransactionDetailTab = false;
            this.manProcessEnded = false;
          })
        )
        .subscribe();
  }

  onCreateChildSpecification(event) {
    environment.production || console.log('*** CreateNewDocumentComponent onCreateChildSpecification ');

    const dddd = new Date();

    if (this.parentDocument) {
      environment.production || console.log('*** CreateNewDocumentComponent onCreateChildSpecification parentDocument: ' + JSON.stringify(this.parentDocument));
      environment.production || console.log('*** CreateNewDocumentComponent onCreateChildSpecification selectedDocument: ' + JSON.stringify(this.selectedDocument));
      this.newDocument = {
        ... this.selectedDocument ?? {
          ...emptyDocument,
          ...{
            DOCID: -2,
            DOCACTIVE: 1,
            DOCTYPE: 7,
            DOCCURRID: this.parentDocument.DOCCURRID,
            DOCCLIENTSID: this.parentDocument.DOCCLIENTSID,
            DOCPERSONID: this.parentDocument.DOCPERSONID,
            DOCCLIDEPID: this.parentDocument.DOCCLIDEPID,
            DOCPCOCLIID: this.parentDocument.DOCPCOCLIID,
            DOCPCODEPID: this.parentDocument.DOCPCODEPID,
            DOCPCOPERID: this.parentDocument.DOCPCOPERID,

            DOCMANCLIID: this.globalsettingsservice.getMainCompanyId(),
            DOCMANPERID: this.globalsettingsservice.getGlobalSettings().mainPersonId,
            DOCMANDEPID: this.parentDocument.DOCMANDEPID,
            DOCLCOCLIID: this.parentDocument.DOCLCOCLIID,
            DOCLCOPERID: this.parentDocument.DOCLCOPERID,
            DOCLCODEPID: this.parentDocument.DOCLCODEPID,

            DOCNOTE1: (this.parentDocument.DOCTYPE == 10) ? this.parentDocument.DOCNOTE1 : '',
            DOCNOTE2: (this.parentDocument.DOCTYPE == 10) ? this.parentDocument.DOCNOTE2 : '',
            PRIMDOCID: this.parentDocument.DOCID,
            DOCFLAG: 0,
            DOCDATE: dddd,
            DOCVALDATE: dddd,
            DOCEXPDATE: dddd,

            items: [],

            SGMGROUPID: this.parentDocument.SGMGROUPID,
          }
        }
      };

          of(this.newDocument)
          .pipe(
            concatMap(ndi => this.fillInChildDocumentDepartmentAndPerson(ndi)),

            finalize(() => { this._finalizeDocumentCreation(6); })
          )
          .subscribe();

      environment.production || console.log('*** CreateNewDocumentComponent onCreateChildSpecification 3: ' + JSON.stringify(this.newDocument));
    }
  }

  onCreateChildFormular(event) {
    environment.production || console.log('*** CreateNewDocumentComponent onCreateChildFormular ');

    const dddd = new Date();

    if (this.parentDocument) {
      environment.production || console.log('*** CreateNewDocumentComponent onCreateChildFormular parentDocument: ' + JSON.stringify(this.parentDocument));
      environment.production || console.log('*** CreateNewDocumentComponent onCreateChildFormular selectedDocument: ' + JSON.stringify(this.selectedDocument));
      this.newDocument = {
        ... this.selectedDocument ?? {
          ...emptyDocument,
          ...{
            DOCID: -2,
            DOCACTIVE: 1,
            DOCTYPE: 16,
            DOCCURRID: this.parentDocument.DOCCURRID,
            DOCCLIENTSID: this.parentDocument.DOCCLIENTSID,
            DOCPERSONID: this.parentDocument.DOCPERSONID,
            DOCCLIDEPID: this.parentDocument.DOCCLIDEPID,
            DOCPCOCLIID: this.parentDocument.DOCPCOCLIID,
            DOCPCODEPID: this.parentDocument.DOCPCODEPID,
            DOCPCOPERID: this.parentDocument.DOCPCOPERID,

            DOCMANCLIID: this.globalsettingsservice.getMainCompanyId(),
            DOCMANPERID: this.globalsettingsservice.getGlobalSettings().mainPersonId,
            DOCMANDEPID: this.parentDocument.DOCMANDEPID,
            DOCLCOCLIID: this.parentDocument.DOCLCOCLIID,
            DOCLCOPERID: this.parentDocument.DOCLCOPERID,
            DOCLCODEPID: this.parentDocument.DOCLCODEPID,

            DOCNOTE1: this.parentDocument.DOCNOTE1,
            DOCNOTE2: this.parentDocument.DOCNOTE2,
            PRIMDOCID: this.parentDocument.DOCID,
            DOCFLAG: 0,
            DOCDATE: dddd,
            DOCVALDATE: dddd,
            DOCEXPDATE: dddd,

            items: [],

            SGMGROUPID: this.parentDocument.SGMGROUPID,
          }
        }
      };

          of(this.newDocument)
          .pipe(
            concatMap(ndi => this.fillInChildDocumentDepartmentAndPerson(ndi)),

            finalize(() => { this._finalizeDocumentCreation(16); })
          )
          .subscribe();
      environment.production || console.log('*** CreateNewDocumentComponent onCreateChildFormular 3: ' + JSON.stringify(this.newDocument));
    }
  }

  onSelectedIds(event) {
    environment.production || console.log('*** CreateNewDocumentComponent onSelectedIds ' + JSON.stringify(event));

    this.newDocument.DOCCLIENTSID = event.MAINCLIID;
    // `WY_tvf_smartSearchClient` returns 0 (not null) for MAINPERID/PERSID when the
    // matched row has no default responsible contact -- e.g. a legal entity search
    // result with nobody set as PERSRESPONSIBLE. Assigning that 0 straight into
    // DOCPERSONID/DOCPCOPERID leaves the field looking "set" (label shows "(0)")
    // while app-personselector can never resolve PERSID 0 to a real contact, so the
    // dropdown stays permanently empty with no way to notice. `|| null` lets
    // app-personselector's own `firstAvailable` fallback (wired below) pick a real
    // contact instead.
    this.newDocument.DOCPERSONID = event.MAINPERID || null;
    this.newDocument.DOCPCOCLIID = event.CLIID;
    this.newDocument.DOCPCOPERID = event.PERSID || null;

    this.cliCompanySubs$.next(this.newDocument.DOCCLIENTSID);
  }

  // this event just update newDocument reference from child component
  // without any additional logic and it is suspicious why it is needed
  //
  // by fact next procedure made alsmost the same but with additional logic to even the person and department
  // so maybe this procedure is obsolete

  onNewDocumentUpdate(event: Document) {
    environment.production || console.log('*** CreateNewDocumentComponent onNewDocumentUpdate ' + JSON.stringify(event));

  }

  // For Inventory and Transaction new document needs to align departments and persons by client and legal entity
  // so we need to do several async calls in sequence
  // and wait until all are done
  // Than we emit newDocumentChange event to parent component
  // but by fact that parent component already has reference to newDocument
  // so emit event just inform parent component that newDocument is somehow changed

  onNewInventoryUpdate(event: Document) {
    environment.production || console.log('*** CreateNewDocumentComponent onNewInventoryUpdate ' + JSON.stringify(event));

    this.newDocument = event;

    // It is important to set these properties for inventory
    // because Inventory is always created for local company
    this.newDocument.DOCPCOCLIID = this.newDocument.DOCLCOCLIID;
    this.newDocument.DOCCLIDEPID = this.newDocument.DOCMANDEPID;

    of(event).pipe(

      concatMap(ndi => this.fillInChildDocumentDepartmentAndPerson(ndi).pipe(
        map(prs => {

          // This section added especially for below comment
          // Force change detection - breaks the newDocuments array reference !!!
          // But without it the child component does not detect the changes in newDocument !!!

          return this.newDocument;
        }))),

      finalize(() => {
        environment.production || console.table(this.newDocument);
      })
      )
      .subscribe();
    }

  // looks like duplicate of onNewInventoryUpdate
  // but maybe in future there will be some difference
  // so let it be separate procedure

  onNewTransactionUpdate(event: Document) {
    environment.production || console.log('*** CreateNewDocumentComponent onNewTransactionUpdate ' + JSON.stringify(event));

    this.newDocument = event;

    of(event).pipe(

      concatMap(ndi => this.fillInChildDocumentDepartmentAndPerson(ndi).pipe(
        map(prs => {

          // This section added especially for below comment
          // Force change detection - breaks the newDocuments array reference !!!
          // But without it the child component does not detect the changes in newDocument !!!

          return this.newDocument;
        }))),
    )
      .subscribe();
  }

  // For multiple document creation from transaction, specification, formular or inventory

  onCreateNewDocuments(event: Document[]) {
    environment.production || console.log('*** CreateNewDocumentComponent onCreateNewDocuments ' + JSON.stringify(event));

    this.newDocuments = event;

    // Arbitrary
    // TODO: try to find right place to filp transaction accordeonTab
    this.manProcessEnded = true;
  }

  /**
   * Dynamically extracts the property names from the first object in an array.
   * @param dataArray The array of objects.
   * @returns An array of strings representing the property names, or an empty array if the input is empty.
   */
  getFields(dataArray: Record<string, unknown>[]): string[] {
    if (!dataArray || dataArray.length === 0) {
      return [];
    }
    return Object.keys(dataArray[0]);
  }
  // Catch transaction result from child component
  getTransactionResult(event: Record<string, unknown>[]) {
    environment.production || console.log('*** CreateNewDocumentComponent onGetTransactionResult ' + JSON.stringify(event));

    this.transactionResult = event;
    this.transactionResultColumns = this.getFields(this.transactionResult);
  }
}
